export default {
  PersonalTagType: "Personal tags",
  ProjectTagType: "Project tags",
};
